webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(53)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(45),
  /* template */
  __webpack_require__(81),
  /* scopeId */
  "data-v-10abd0de",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


var BASE_URL = "https://qlwalmj9zj.execute-api.ap-northeast-1.amazonaws.com/prod";

var toUrl = function toUrl(path) {
  for (var _len = arguments.length, subPath = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    subPath[_key - 1] = arguments[_key];
  }

  return BASE_URL + path + subPath.join('/');
};

var getInstance = function getInstance(token) {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    headers: { 'x-auth': token }
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({

  login: function login(email, password) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.post(toUrl('/users/login'), {
      email: email, password: password
    }).then(function (res) {
      return res.data;
    });
  },

  me: function me(token) {
    return getInstance(token).get(toUrl('/users/me')).then(function (res) {
      return res.data;
    });
  },

  postVideo: function postVideo(token, video) {
    return getInstance(token).post(toUrl('/videos'), video).then(function (res) {
      return res.data;
    });
  },

  postVideoTest: function postVideoTest(token, video) {
    return getInstance(token).post(toUrl('/videos/test'), video).then(function (res) {
      return res.data;
    });
  },

  getVideos: function getVideos() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(toUrl('/videos')).then(function (res) {
      return res.data;
    });
  },

  getRandomVideos: function getRandomVideos() {
    var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 9;

    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(toUrl('/videos?random=' + size)).then(function (res) {
      return res.data;
    });
  },

  getVideo: function getVideo(id) {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(toUrl('/videos/', id)).then(function (res) {
      return res.data;
    });
  },

  editVideo: function editVideo(token, video, id) {
    return getInstance(token).patch(toUrl('/videos/', id), video).then(function (res) {
      return res.data;
    });
  },

  deleteVideo: function deleteVideo(token, id) {
    return getInstance(token).delete(toUrl('/videos/', id)).then(function (res) {
      return res.data;
    });
  },

  postGif: function postGif(token, id, gif) {
    return getInstance(token).post(toUrl('/gifs/', id), gif).then(function (res) {
      return res.data;
    });
  },

  getGifs: function getGifs() {
    return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get(toUrl('/gifs')).then(function (res) {
      return res.data;
    });
  }
});

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Base_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Base_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Base_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_vue__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Home_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Home_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoArchives__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_VideoArchives___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_VideoArchives__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VideoPlayer_vue__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_VideoPlayer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_VideoPlayer_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Thisism_vue__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Thisism_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_Thisism_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_More_vue__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_More_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_More_vue__);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var routes = [{
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_2__components_Base_vue___default.a,
  children: [{
    path: '', component: __WEBPACK_IMPORTED_MODULE_3__components_Home_vue___default.a, name: 'home'
  }, {
    path: 'video-archives', component: __WEBPACK_IMPORTED_MODULE_4__components_VideoArchives___default.a, name: 'video-archives'
  }, {
    path: 'player/:ytid', component: __WEBPACK_IMPORTED_MODULE_5__components_VideoPlayer_vue___default.a, name: 'video-player'
  }, {
    path: 'thisism', component: __WEBPACK_IMPORTED_MODULE_6__components_Thisism_vue___default.a, name: 'thisism'
  }, {
    path: 'more', component: __WEBPACK_IMPORTED_MODULE_7__components_More_vue___default.a, name: 'more'
  }]
}];

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: routes,
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(95);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({

  state: {
    videos: []
  },
  getters: {
    getVideos: function getVideos(state) {
      return state.videos;
    }
  },
  mutations: {
    addVideos: function addVideos(state, payload) {
      state.videos = payload;
    },
    addVideo: function addVideo(state, payload) {
      if (!state.videos) {
        state.videos = {};
      }

      state.videos[payload.key] = payload.value;
    },
    deleteVideo: function deleteVideo(state, key) {
      console.log('mutations.deleteVideo key = ' + key);
      delete state.videos[key];
    }

  },
  actions: {
    login: function login(context, payload) {
      context.commit('login', payload);
    },
    logout: function logout(context) {
      context.commit('logout');
    }
  }

}));

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(59)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(39),
  /* template */
  __webpack_require__(87),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export MEDIA_TYPES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VIDEO_CATEGORIES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toName; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);


var MEDIA_TYPES = [{ value: 1, name: 'Youtube' }, { value: 2, name: 'Image' }];

var VIDEO_CATEGORIES = [{ value: 1, name: 'Music Video' }, { value: 2, name: 'Document' }, { value: 3, name: 'Live' }, { value: 4, name: 'Trailer' }, { value: 5, name: 'Other' }];

var toName = function toName(array, value) {
  if (!array || !value) return '';

  value = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.toSafeInteger(value);
  var found = __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.find(array, { value: value });
  return found.name ? found.name : value;
};

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__App_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__router__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(17);












__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_awesome_swiper___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_youtube_embed__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_5__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_4__App_vue___default.a }
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Header_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Header_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Footer_vue__);





/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    appHeader: __WEBPACK_IMPORTED_MODULE_0__Header_vue___default.a,
    appFooter: __WEBPACK_IMPORTED_MODULE_1__Footer_vue___default.a
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider_vue__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Slider_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RandomArchives_vue__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__RandomArchives_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__RandomArchives_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    appSlider: __WEBPACK_IMPORTED_MODULE_0__Slider_vue___default.a,
    appNavigation: __WEBPACK_IMPORTED_MODULE_1__Navigation_vue___default.a,
    appRandomArchives: __WEBPACK_IMPORTED_MODULE_2__RandomArchives_vue___default.a
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_thisism_api__ = __webpack_require__(6);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videos: {}
    };
  },

  methods: {},
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api_thisism_api__["a" /* default */].getRandomVideos(9).then(function (data) {
      _this.videos = data;
    });
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_thisism_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_swiper_dist_css_swiper_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__);






/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      gifs: [],

      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },

        autoplay: {
          delay: 12000
        }
      }

    };
  },

  computed: {
    swiper: function swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  methods: {
    onclick: function onclick() {
      var clicked = this.gifs[this.$refs.mySwiper.swiper.clickedIndex];
      this.$router.push({ name: 'video-player', params: { ytid: clicked.ytid } });
    }
  },
  components: {
    swiper: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiper"],
    swiperSlide: __WEBPACK_IMPORTED_MODULE_2_vue_awesome_swiper__["swiperSlide"]
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_0__api_thisism_api__["a" /* default */].getGifs().then(function (data) {
      _this.gifs = data;
    });
  }
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navigation_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },

  components: {
    appNavigation: __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default.a
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_thisism_api__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoArchivesCategory_vue__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VideoArchivesCategory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__VideoArchivesCategory_vue__);








/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videosByCategory: {}
    };
  },

  components: {
    appCategory: __WEBPACK_IMPORTED_MODULE_3__VideoArchivesCategory_vue___default.a,
    appNavigation: __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default.a
  },
  created: function created() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_1__api_thisism_api__["a" /* default */].getVideos().then(function (data) {
      _this.videosByCategory = __WEBPACK_IMPORTED_MODULE_2_lodash___default.a.groupBy(data, 'category');
    });
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__consts__ = __webpack_require__(37);





/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['categoryId', 'videos'],
  data: function data() {
    return {
      size: 3,
      currentPage: 0
    };
  },

  computed: {
    hasNext: function hasNext() {
      return this.totalPage() > this.currentPage + 1;
    },
    hasPrevious: function hasPrevious() {
      return this.currentPage > 0;
    },
    offset: function offset() {
      return this.currentPage * this.size;
    },
    filterdVideos: function filterdVideos() {
      return __WEBPACK_IMPORTED_MODULE_0_lodash___default.a.slice(this.videos, this.offset, this.offset + this.size);
    }
  },
  methods: {
    totalPage: function totalPage() {
      if (!this.videos) return 0;
      return Math.ceil(this.videos.length / this.size);
    },
    toNext: function toNext() {
      if (this.hasNext) {
        this.currentPage++;
      }
    },
    toPrevious: function toPrevious() {
      if (this.hasPrevious) {
        this.currentPage--;
      }
    },
    getCategoryName: function getCategoryName(value) {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__consts__["a" /* toName */])(__WEBPACK_IMPORTED_MODULE_1__consts__["b" /* VIDEO_CATEGORIES */], value);
    }
  }
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Navigation_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      videoId: this.$route.params.id,
      playerWidth: '100%',
      playerHeight: '500px',
      playerVars: {
        autoplay: 1
      }
    };
  },

  methods: {
    ready: function ready(player) {
      this.player = player;
    },
    playing: function playing(player) {},
    change: function change() {},
    stop: function stop() {
      this.player.stopVideo();
    },
    pause: function pause() {
      this.player.pauseVideo();
    },
    back: function back() {
      this.$router.go(-1);
    }
  },
  components: {
    appNavigation: __WEBPACK_IMPORTED_MODULE_0__Navigation_vue___default.a
  },
  created: function created() {}
});

/***/ }),
/* 52 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 53 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 57 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 58 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 59 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 60 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 61 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 62 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(54)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(40),
  /* template */
  __webpack_require__(82),
  /* scopeId */
  "data-v-29a796ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(61)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(41),
  /* template */
  __webpack_require__(89),
  /* scopeId */
  "data-v-d55f6c36",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(60)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(42),
  /* template */
  __webpack_require__(88),
  /* scopeId */
  "data-v-92faa452",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(55)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(43),
  /* template */
  __webpack_require__(83),
  /* scopeId */
  "data-v-34cd6ba9",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(57)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(44),
  /* template */
  __webpack_require__(85),
  /* scopeId */
  "data-v-44bb871f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(58)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(46),
  /* template */
  __webpack_require__(86),
  /* scopeId */
  "data-v-610c8b9e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(63)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(47),
  /* template */
  __webpack_require__(91),
  /* scopeId */
  "data-v-fada0baa",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(64)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(48),
  /* template */
  __webpack_require__(92),
  /* scopeId */
  "data-v-fb3c976a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(52)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(49),
  /* template */
  __webpack_require__(80),
  /* scopeId */
  "data-v-0c07ceb2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(56)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(84),
  /* scopeId */
  "data-v-392a76d0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(62)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(90),
  /* scopeId */
  "data-v-de19603c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container row",
    attrs: {
      "id": "video-archives"
    }
  }, [_c('app-navigation'), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._l((_vm.videosByCategory), function(videos, categoryId) {
    return _c('div', {
      staticClass: "category row"
    }, [_c('app-category', {
      attrs: {
        "videos": videos,
        "categoryId": categoryId
      }
    })], 1)
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-archives-title-wrapper"
  }, [_c('h4', {
    staticClass: "video-archives-title"
  }, [_vm._v("VIDEO ARCHIVES")])])
}]}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'thisism'
      }
    }
  }, [_vm._v("THISISM")])], 1), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'video-archives'
      }
    }
  }, [_vm._v("VIDEO")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'more'
      }
    }
  }, [_vm._v("&MORE")])], 1), _vm._v(" "), _vm._m(1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "http://blog.livedoor.jp/thisism/",
      "target": "_blank"
    }
  }, [_vm._v("BLOG")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "mailto:thisismgml@gmail.com"
    }
  }, [_vm._v("CONTACT")])])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bold",
    attrs: {
      "id": "base"
    }
  }, [_c('app-header'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bounce"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "home"
    }
  }, [_c('app-slider'), _vm._v(" "), _c('app-navigation'), _vm._v(" "), _c('app-random-archives')], 1)
},staticRenderFns: []}

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "category row"
  }, [_c('p', {
    staticClass: "category_title"
  }, [_vm._v(_vm._s(_vm.getCategoryName(_vm.categoryId)))]), _vm._v(" "), _c('div', {
    staticClass: "bar_section"
  }, [_c('div', {
    staticClass: "prev_section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasPrevious),
      expression: "hasPrevious"
    }],
    staticClass: "arrow left",
    on: {
      "click": _vm.toPrevious
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "main_section"
  }, _vm._l((_vm.filterdVideos), function(v) {
    return _c('router-link', {
      key: v.ytid,
      staticClass: "video",
      style: ({
        'background-image': 'url(' + v.thumbnail + ')'
      }),
      attrs: {
        "to": {
          name: 'video-player',
          params: {
            ytid: v.ytid
          }
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(v.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(v.note))])])])])])
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "next_section"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasNext),
      expression: "hasNext"
    }],
    staticClass: "arrow right",
    on: {
      "click": _vm.toNext
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-right",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])])])
},staticRenderFns: []}

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "more"
    }
  }, [_c('h1', [_vm._v("more")]), _vm._v(" "), _c('p', [_vm._v("coming soon ...")])])
}]}

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container",
    attrs: {
      "id": "random-archives"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.videos), function(v) {
    return _c('router-link', {
      key: v.ytid,
      staticClass: "video",
      style: ({
        'background-image': 'url(' + v.thumbnail + ')'
      }),
      attrs: {
        "to": {
          name: 'video-player',
          params: {
            ytid: v.ytid
          }
        }
      }
    }, [_c('div', {
      staticClass: "overlay"
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('h4', {
      staticClass: "title"
    }, [_vm._v(_vm._s(v.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(v.note))])])])])])
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "random-archives-title-wrapper"
  }, [_c('h4', {
    staticClass: "random-archives-title"
  }, [_vm._v("RANDOM ARCHIVES")])])
}]}

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "root"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "header"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'home'
      }
    }
  }, [_c('div', {
    staticClass: "logo"
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "container row u-full-width"
  }, [_c('div', {
    staticClass: "copyright"
  }, [_vm._v("© 2019 Thisism")]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/thisism_ig/?hl=ja",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-instagram",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://twitter.com/thisismtwt",
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-twitter",
    attrs: {
      "aria-hidden": "true"
    }
  })])])])
}]}

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "video"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('app-navigation'), _vm._v(" "), _c('div', {
    staticClass: "row player"
  }, [_c('youtube', {
    attrs: {
      "video-id": _vm.$route.params.ytid,
      "player-width": _vm.playerWidth,
      "player-height": _vm.playerHeight,
      "player-vars": _vm.playerVars
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('i', {
    staticClass: "fa fa-chevron-left",
    attrs: {
      "aria-hidden": "true"
    },
    on: {
      "click": _vm.back
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container row",
    attrs: {
      "id": "slider"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    attrs: {
      "options": _vm.swiperOption
    },
    on: {
      "click": _vm.onclick
    }
  }, [_vm._l((_vm.gifs), function(g) {
    return _c('swiper-slide', {
      key: g.id,
      staticClass: "swiper-lazy",
      style: ({
        'background-image': 'url(' + g.gif + ')'
      })
    }, [_c('div', {
      staticClass: "caption"
    }, [_c('div', {
      staticClass: "title-bg"
    }, [_c('p', {
      staticClass: "title"
    }, [_vm._v(_vm._s(g.title))])]), _vm._v(" "), _c('div', {
      staticClass: "note-bg"
    }, [_c('p', {
      staticClass: "note"
    }, [_vm._v(_vm._s(g.note))])])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination swiper-pagination-white",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "thisism"
    }
  }, [_c('app-navigation'), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ten columns offset-by-one"
  }, [_c('p', [_vm._v("\n      2010年末、｢自分達で何かしなくてはいけない｣という曖昧な危機感を覚える。そして｢ビデオカメラとMacがあるから映像をやろう｣という結論に至る。\n      またその当時、ふと手に取った本が｢～主義｣/｢～ism｣をまとめた内容であったことから｢ism｣に着想し、見栄えの良さと唯一の組み合わせを探して、｢This-ism｣転じて｢Thisism (ディスイズム)｣を活動名とする。\n      手始めに友人のニートが働くまでを撮り、荒編集した内容をYOUTUBEへ公開する。身内からの小さな反響にほくそ笑む。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      その後、ドキュメントと実験的な動画を軸に作品を作っていこうと息巻く。しかし、特に何かあるわけでもなく腐る。\n      それと同じくして｢ビデオ出来るなら何かやってよ｣という軽いノリで、少しづつバンド関連の動画を作ることが増え始める。\n      当初はバンドをやっている友達が多かったことから、持ち前のひねくれ性でバンド関連の動画は避けていたものの、話が少しずつ増えるに連れて喜びを感じ、欲求が増していく...というよりは素直になる。\n      大きく気持ちを揺り動かしてくれたのはメンバーが身近にいたA PAGE OF PUNKとTHINK AGAINの存在だったと思う。\n    ")]), _vm._v(" "), _c('p', [_vm._v("\n      素直なれたので｢もっとやろう｣という思いで今に至る。\n    ")])])
}]}

/***/ })
],[38]);


// WEBPACK FOOTER //
// static/js/app.1b1ec72573488c82abee.js